import Vue from "vue";
import config from "./config/config";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import i18n from "./i18n";
import axios from "axios";
import { injectVersionControlRequest } from "./utils/axiosUtil";
import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.use(BootstrapVue);

library.add(far, fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

const base = axios.create({
  baseURL: config.apiUrl,
  timeout: 28000
});

injectVersionControlRequest(base);
axios.defaults.headers.common["token"] = config.token;

Vue.prototype.$http = base;

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
